import _classCallCheck from "/app/node_modules/babel-runtime/helpers/classCallCheck";
import _createClass from "/app/node_modules/babel-runtime/helpers/createClass";
export var SupervisorApi = function () {
    function SupervisorApi(axios, store) {
        _classCallCheck(this, SupervisorApi);

        this.axios = axios;
    }

    _createClass(SupervisorApi, [{
        key: "updatePasswordSupervisor",
        value: function updatePasswordSupervisor(data) {
            return this.axios.$post("/supervisor/supervisors/update-password", data);
        }
    }, {
        key: "editSupervisor",
        value: function editSupervisor(data) {
            return this.axios.$post("/supervisor/supervisors/edit-Supervisor", data);
        }
    }, {
        key: "validationPasswordSupervisor",
        value: function validationPasswordSupervisor(data, cancelToken) {
            return this.axios.$post("/supervisor/supervisors/validation-password", data, { cancelToken: cancelToken });
        }
    }]);

    return SupervisorApi;
}();


//////////////////
// WEBPACK FOOTER
// ./src/api/supervisor.js
// module id = ./src/api/supervisor.js
// module chunks = 34